import React from 'react'
import { mount, shallow } from 'enzyme'
import Form1065 from '../forms/Form1065'

describe('<Form1065 />', () => {
  const formData = [
    {
      name: 'Bob Ross',
      tin: '435-09-5748',
      address: '89 49th Street',
      apt: 4453,
      city: 'Newark',
      state: 'NJ',
      zip: '42451',
      valid: true
    },
    {
      name: 'Jim Jones',
      tin: '42',
      address: '',
      apt: 424,
      city: 'San Leandro',
      state: 'CA',
      zip: '88549',
      valid: false
    },
    {
      name: '',
      tin: '22-4444234',
      address: 'this is a valid address',
      state: 'AK',
      city: 'Anchorage',
      zip: '34923',
      valid: false
    },
    {
      name: 'Good Name',
      tin: '22-3339876',
      state: 'asdfadsf',
      zip: '24293',
      valid: false
    }
  ]
  const props = {
    onDataChange: () => { },
    year: 2018,
    defaults: {}
  }
  it('should render without crashing', () => {
    mount(<Form1065 defaults={{}} onDataChange={() => { }} year={2018} />)
  })
  it('should call its onDataChange prop any time a field is modified', () => {
    const onDataChangeMock = jest.fn()
    const wrapper = mount(
      <Form1065 defaults={{}} onDataChange={onDataChangeMock} year={2018} />
    )
    const inputs = wrapper.find('input')
    inputs.forEach(input => {
      input.simulate('change')
    })
    // Form1065 tests its validity on mount (componentDidMount) so we add 1
    // additional call
    expect(onDataChangeMock.mock.calls.length).toEqual(inputs.length + 1)
  })
  it('should correctly validate form data', () => {
    const wrapper = shallow(
      <Form1065 {...props} />
    )
    const instance = wrapper.instance()
    for (const data of formData) {
      const testData = { ...data }
      // This step is necessary to prevent the validator from attempting
      // to validate the 'valid' field
      delete testData.valid
      expect(instance.validate(testData)).toEqual(data.valid)
    }
  })
})